"use strict";

import Common from "./Common";
import CommonGame from "./CommonGame";
import GallerySelectionScene from "./scenes/GallerySelectionScene";
import ImageSelectionScene from "./scenes/ImageSelectionScene";
import GameScene from "./scenes/GameScene";
import MainScene from "./scenes/MainScene";
import SavedData from "./SavedData";

/*

 var AudioParams = require("./AudioParams");
 var Common = require("./Common");
 var CommonGame = require("./CommonGame");
 var SavedData = require("./SavedData");
 var MainScene = require("./scenes/MainScene");
 var GameScene = require("./scenes/GameScene");
 var ImageSelectionScene = require("./scenes/ImageSelectionScene");
 var GallerySelectionScene = require("./scenes/GallerySelectionScene");
 */
export default class Application {
    constructor() {

    }

    static init() {
        Common.assets.texture = Common.assets.texture.bind(Common.assets);


        let cfg = Common.assets.getJSON("config");
        CommonGame.ARR_COLOUR_IT_SPRITE_ID = cfg.ARR_COLOUR_IT_SPRITE_ID;

        CommonGame.ARR_DRAW_IT_SPRITE_ID = cfg.ARR_DRAW_IT_SPRITE_ID;

        Application.showMainScene();

        Common.savedData = new SavedData();
        Common.savedData.init();
    }

    /**
     * @returns {Scene}
     */
    static showMainScene() {

        Common.paused = false;

        const scene = new MainScene();

        scene.signals.next.add(function () {
            Application.showGallerySelectionScene();
        }, this);

        Common.scene.show(scene);

        return scene;

    }

    static showGameScene() {

        const scene = new GameScene();

        scene.signals.next.add(function (scene) {
            Application.showGameScene();
        }, this);

        scene.signals.previous.add(function (scene) {
            Application.showImageSelectionScene();
        }, this);

        scene.signals.home.add(function (scene) {
            Application.showMainScene();
        }, this);

        Common.scene.show(scene);

        return scene;
    }

    static showImageSelectionScene() {

        const scene = new ImageSelectionScene();

        scene.signals.next.add(function (scene) {
            Application.showGameScene();
        }, this);

        scene.signals.previous.add(function (scene) {
            Application.showGallerySelectionScene();
        }, this);

        scene.signals.home.add(function (scene) {
            Application.showMainScene();
        }, this);

        Common.scene.show(scene);

        return scene;
    }

    static showGallerySelectionScene() {

        const scene = new GallerySelectionScene();

        scene.signals.next.add(function (scene) {
            Application.showImageSelectionScene();
        }, this);

        scene.signals.previous.add(function (scene) {
            Application.showMainScene();
        }, this);

        scene.signals.home.add(function (scene) {
            Application.showMainScene();
        }, this);

        Common.scene.show(scene);

        return scene;
    }

}